export default "__VITE_ASSET__DyExdixl__"